import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { FaTrash } from 'react-icons/fa';
import { VaccinationsGet } from 'apiServices/reducer/apiService';
import { deleteVaccination } from 'apiServices/reducer/dialogApiService';
import '../../../styles/user.css';
import CustomSuccessModal from '../../../components/CustomSuccessModal';
import { showPmrDeleteConfirm } from '../../../utils/swalUtils';


const ManageVaccinationModal = ({ show, onHide, refreshVaccinationData, userId }) => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.apiService?.token);
    const [vaccinations, setVaccinations] = useState([]);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isDeleted, setIsDeleted] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const fetchVaccinations = async () => {
        try {
            const response = await dispatch(VaccinationsGet({ UserID: userId, token }));
            if (response?.payload && Array.isArray(response.payload)) {
                const activeVaccinations = response.payload.filter(vaccine => vaccine.is_active !== false);
                setVaccinations(activeVaccinations);
            } else {
                setVaccinations([]);
            }
        } catch {
            setVaccinations([]);
        }
    };

    useEffect(() => {
        if (show) {
            fetchVaccinations();
            setIsDeleted(false);
        }
    }, [show]);

    const handleDelete = async (vaccinationId) => {
        if (!vaccinationId || isNaN(vaccinationId)) {
            return;
        }
        if (isDeleting) return;

        showPmrDeleteConfirm({
            message: 'You want to delete this vaccination? This action cannot be undone.',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    setIsDeleting(true);
                    const vaccineIdNum = Number(vaccinationId);
                    const response = await dispatch(deleteVaccination({
                        VaccinationID: vaccineIdNum,
                        UserID: userId,
                        token: token
                    })).unwrap();

                    if (response?.success || response?.OutputMessage?.toLowerCase().includes('success')) {
                        setSuccessMessage('Vaccination deleted successfully!');
                        setShowSuccessModal(true);
                        setVaccinations(prev => prev.filter(v => v.vaccine_id !== vaccineIdNum));
                        setIsDeleted(true);
                    } else {
                    }
                } catch (error) {
                } finally {
                    setIsDeleting(false);
                }
            }
        });
    };

    const handleClose = () => {
        // 🆕 Pass true if deleted, else false
        onHide(isDeleted);
    };

    return (
        <Modal show={show} onHide={handleClose} centered dialogClassName="wider-modal" backdrop="static" keyboard={false}>
            <Modal.Header closeButton className='modal-header-bg'>
                <Modal.Title className='text-capitalize'>Manage Vaccination</Modal.Title>
            </Modal.Header>
            <Modal.Body className="manage-vaccination-modal-body">
                {vaccinations.length === 0 ? (
                    <p className="text-muted">No vaccination records found.</p>
                ) : (
                    vaccinations.map((vaccine) => (
                        <Row key={vaccine.vaccine_id} className="align-items-center py-2 border-bottom">
                            <Col md={6}>
                                <strong>{vaccine.vaccine_name || "N/A"}</strong><br />
                                <small className="text-muted">{vaccine.manufacturer || "N/A"}</small>
                            </Col>
                            <Col md={5} className="manage-vaccination-right">
                                <span className="manage-vaccination-dose" title={`Dose ${vaccine.dose_number || "N/A"}`}>
                                    <span className="manage-vaccination-dose-label">Dose</span>
                                    <span className="manage-vaccination-dose-value">{vaccine.dose_number || "N/A"}</span>
                                </span>
                                <span className="manage-vaccination-date" style={{ whiteSpace: 'nowrap' }}>
                                    {vaccine.date || "N/A"}
                                </span>
                                <Button
                                    variant="link"
                                    className="p-0"
                                    onClick={() => handleDelete(vaccine.vaccine_id)}
                                    title="Delete Vaccination"
                                    disabled={isDeleting}
                                    style={{ boxShadow: "none" }}
                                >
                                    <FaTrash className="text-danger" style={{ fontSize: 20 }} />
                                </Button>
                            </Col>
                        </Row>
                    ))
                )}
            </Modal.Body>
            <Modal.Footer className='modal-header-bg'>
                <Button variant="danger" onClick={handleClose}>Close</Button>
            </Modal.Footer>
            <CustomSuccessModal
                show={showSuccessModal}
                onHide={() => { setShowSuccessModal(false); setSuccessMessage(''); }}
                message={successMessage}
            />
        </Modal>
    );
};

export default ManageVaccinationModal;